import { t } from 'ttag'

export const AREA_COLUMN = 'area'
export const VALUE_LEVEL_COLUMN = 'value'
export const PERSONALITY_SCORE_COLUMN = 'personalityScore'
export const INTEREST_SCORE_COLUMN = 'interestScore'
export const CATEGORY_COLUMN = 'category'

const DESCENDING_SORT_FIELDS = [
  VALUE_LEVEL_COLUMN,
  PERSONALITY_SCORE_COLUMN,
  INTEREST_SCORE_COLUMN,
]

export const getDefaultSortDirection = field =>
  DESCENDING_SORT_FIELDS.includes(field) ? 'descending' : 'ascending'

export const getColumns = () => {
  return [
    { header: t`Talent Areas`, field: AREA_COLUMN },
    { header: t`Match`, field: VALUE_LEVEL_COLUMN },
    { header: t`Personality`, field: PERSONALITY_SCORE_COLUMN },
    { header: t`Interest`, field: INTEREST_SCORE_COLUMN },
    { header: t`Category`, field: CATEGORY_COLUMN },
  ]
}
